export default defineNuxtRouteMiddleware((to) => {
  if (true) {
    if(to.fullPath.includes('/admin')) {
      if (useAdminDashboard().facilities.length > 0) {
        return;
      }

      const fetchFacilities = async () => {
        const { data } = await useApiV3().get('/facilities');

        const facilities = data?.items;
        useAdminDashboard().setFacilities(facilities);
      }

      fetchFacilities()
    }
  }
});
